import { get } from 'lodash';
import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLogMonitor from '../tableLogMonitor';
export default {
  title: 'Live backend sessions',
  attributeName: 'liveLogs',    
  websocketChannel: 'live-monitor-liveId',
  websocketSessionParams: ['liveId'],
  websocketItem: 'tableMonitor',
  sessionParams: [],
  idAttribute: 'id',
  fields: [
    
    {
      label: 'Table Monitor',
      attributeName: 'tableMonitor',
      type: FormInputTypes.TABLE,
      mode:'NORMAL',
      helpText: '',
      configFile: tableLogMonitor,
    },  
    {
      attributeName: 'downloadCSV',
      type: FormInputTypes.BUTTON_FORM,
      mode:'button',
      actionUrl:'live/logs/export',
      actionParams: ['id'],
      actionIsDownload: true,
      label: 'Export Table',
      className:'ml-3 float-left download'
    },
  ],
};
